var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSearch = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.037 10.268a5.769 5.769 0 1 0-11.537 0 5.769 5.769 0 0 0 11.537 0zm-1.114 5.88a7.463 7.463 0 0 1-4.655 1.62 7.498 7.498 0 0 1-7.499-7.5c0-4.142 3.357-7.499 7.5-7.499 4.142 0 7.499 3.357 7.499 7.5 0 1.759-.606 3.378-1.62 4.654l4.829 4.828a.865.865 0 0 1-1.222 1.222l-4.832-4.824z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-search.54b4fb22.svg";
export { ForwardRef as ReactComponent };